import React, {Component} from 'react';
import { Link } from "react-router-dom";

import Counter from './Counter';
import PopupFooter from './PopupFooter';
import tag from './Analytics';


class Welcome extends Component {

  constructor(props) {
    super(props);
    tag('home');
  }

  render() {
    return (
      <div className="gp-popup gp-popup-welcome">
        <div className="gp-close-icon" onClick={this.props.onClose}>
          <span className="icon">
            <i className="fa fa-window-close"></i>
          </span>
        </div>
        <div className="gp-content">
          <h1 className="title">
            <span className="gp-subtitle-1">On a tou&middot;tes une raison de se méfier du nucléaire.</span>
            <br/>
            <span className="gp-subtitle-1">Partagez la vôtre&nbsp;!</span>
          </h1>
          <div className="columns is-fullwidth buttons">
            <div className="column gp-column-welcome-twitter">
              <Link to="/twitter" className="button is-fullwidth is-medium gp-button-welcome-twitter">
                <span>Je tweete</span>
                <span className="icon">
                  <i className="fab fa-twitter"></i>
                </span>
              </Link>
            </div>
            <div className="column gp-column-welcome-form">
              <Link to="/add" className="button is-fullwidth is-medium gp-button-welcome-form">
                <span>J'ajoute un message</span>
                <span className="icon">
                  <i className="fas fa-map-marker-alt"></i>
                </span>
              </Link>
            </div>
          </div>

          <Counter/>

          <div className="content">
            <p>
              34 activistes de Greenpeace France qui ont dénoncé le vieillissement des centrales nucléaires françaises seront jugé·es prochainement à Valence. <b>Leur procès se tiendra le 29 juin</b>. Ils et elles ne sont pas seul·es à lancer l’alerte sur le nucléaire et ses dangers : nous avons toutes et tous des raisons légitimes de dire non au nucléaire. Faisons-le savoir&nbsp;!
            </p>

          </div>

          <PopupFooter url="moreinfo" text="En savoir plus"/>

        </div>
      </div>
    )
  }
}

export default Welcome;
